import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { SpinnerService } from '../_services/spinner.service';
import { LoggerService } from '../_services/logger.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

    count = 0;

    constructor(
        private logger: LoggerService,
        private spinner: SpinnerService
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.responseType === 'blob') {
            return next.handle(req);
        }

        this.spinner.show();
        this.count++;

        return next.handle(req)
            .pipe(tap(
                event => {
                    this.logger.log(event);
                },
                error => {
                    this.logger.error(error);
                }
            ), finalize(() => {
                this.count--;
                if (this.count == 0) {
                    this.spinner.hide()
                }
            })
            );
    }
}
